import { useMemo } from 'react';
import { ResourceFilterType, useGetAccessRequestTemplate } from '@client-app-sdk';
import { AccessRequestForm } from '@NewRequest/organisms/AccessRequestForm';
import { Loader } from '@common/ui/Loader';
import { useNavigate } from 'react-router-dom';
import routes from '@routes';
import { FormState } from '@MyRequests/helpers';

function AccessRequestFormWithTemplate({ templateId }: { templateId: string }) {
  const { data: templateData } = useGetAccessRequestTemplate({ id: templateId });
  const navigate = useNavigate();
  const templateFormState: FormState | undefined = useMemo(() => {
    if (!templateData) return undefined;
    const { integrations, resource_types, permissions, resources } = templateData;
    return {
      selectedIntegration: integrations.map((integration) => ({
        value: integration.id,
        label: integration.name,
        subLabel: integration.type,
        icon: integration.icons?.svg,
      }))?.[0],
      selectedResourceType: resource_types.map((resourceType) => ({
        value: resourceType.id,
        label: resourceType.name,
        icon: resourceType.icons?.svg,
      }))?.[0],
      selectedPermission: permissions.map((permission) => ({
        value: permission.id,
        label: permission.name,
      }))?.[0],
      selectedMultiplePermission: permissions.map((permission) => ({
        value: permission.id,
        label: permission.name,
      })),
      selectedResource: resources.map((resource) => ({
        value: `${ResourceFilterType.Id}:${resource.id}`,
        label: resource.path,
        icon: resource.type?.icons?.svg,
      })),
      justification: '',
    };
  }, [templateData]);

  if (!templateFormState) return <Loader />;

  return (
    <AccessRequestForm
      templatesEnabled
      initFormState={templateFormState}
      onSuccess={() => navigate(routes.OpenRequests.path)}
    />
  );
}

export default AccessRequestFormWithTemplate;
